import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  resumeName: {
    marginLeft: theme.spacing(2),
    color: theme.palette.primary.dark,
  },
  resumeText: {
    marginLeft: theme.spacing(2),
    maxHeight: "300px",
    paddingTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    overflow: "auto",
  },
  resumeIcon: {
    color: theme.palette.primary.dark,
  },
  addedText: {
    marginLeft: theme.spacing(2),
    color: "#898989",
  },
  card: {
    // maxWidth: "527px",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
  },
}))

export default styles
